import type { ItemTypeSessionSection } from "@memorang/ui/components/ItemTypeDetailModal";
import type { FrontendRecommendationOption } from "./frontend-option-adapter";

export const buildItemTypeSessionSection = ({
	options,
	selectedSessionId,
	sessionsLabel,
	startLabel,
	starting,
	onSelectSession,
	onStart,
}: {
	options: FrontendRecommendationOption[];
	selectedSessionId?: string;
	sessionsLabel: string;
	startLabel: string;
	starting?: boolean;
	onSelectSession: (id: string) => void;
	onStart: (option: FrontendRecommendationOption) => void;
}): ItemTypeSessionSection | undefined => {
	if (options.length === 0) {
		return undefined;
	}
	const selected =
		options.find(({ id }) => id === selectedSessionId) ?? options[0];
	return {
		sessionsLabel,
		sessions: options.map(({ itemTypeSession }) => itemTypeSession),
		selectedSessionId: selected.id,
		onSelectSession,
		insight: selected.insight,
		startLabel,
		onStart: () => onStart(selected),
		starting,
	};
};
